// extracted by mini-css-extract-plugin
export default {"bigLetter":"AlternatingText_bigLetter__oyve5","smallLetter":"AlternatingText_smallLetter__8NfUB"};